import { SAVE_CALENDAR_DAY } from "./actionTypes";

export default (date, title) => ({
  type: SAVE_CALENDAR_DAY,
  payload: {
    date,
    title
  }
});